// extracted by mini-css-extract-plugin
export default {"box":"UserHistory_box__bP0+o","emailBox":"UserHistory_emailBox__1FP9l","inputBox":"UserHistory_inputBox__QOj9r","submit":"UserHistory_submit__cFRqw"};